import axios from 'axios'
import { getCopilotToken } from '../../scripts/copilot.auth'
import { CopilotThread } from '../../models/copilot.model'
import { attachRetryInterceptor, attachRefreshInterceptor } from '../../scripts/axios.resilience'

const copilotApi = axios.create({
  baseURL: process.env.REACT_APP_COPILOT_API_URL || 'https://copilot-api.digitaladmin.io'
})

copilotApi.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${getCopilotToken()}`
  return config
})

attachRetryInterceptor(copilotApi)
attachRefreshInterceptor(copilotApi)

export async function listThreads(): Promise<CopilotThread[]> {
  const res = await copilotApi.get('/threads')
  return res.data?.data?.items ?? res.data?.items ?? []
}

export async function getThreadMessages(threadId: string, page = 1, limit = 50) {
  const res = await copilotApi.get(`/threads/${threadId}/messages`, { params: { page, limit } })
  return res.data?.data ?? res.data   // { items, pagination }
}

export async function createThread(title: string, documentIds?: string[]): Promise<CopilotThread> {
  const res = await copilotApi.post('/threads', { title, ...(documentIds?.length ? { documentIds } : {}) })
  return res.data?.data ?? res.data
}

export async function getBatchJob(batchJobId: string): Promise<any> {
  const res = await copilotApi.get(`/batch/${batchJobId}`)
  return res.data?.data ?? res.data
}
